/**
 * Strip a phone string down to digits only (no country code).
 * "( 917) 555-1234" → "9175551234"
 */
export function cleanPhone(phone: string): string {
  const digits = phone.replace(/\D/g, '');
  return digits.length === 11 && digits.startsWith('1')
    ? digits.slice(1)
    : digits;
}

/**
 * Format phone for display: (917) 555-1234
 */
export function formatPhone(phone: string): string {
  const d = cleanPhone(phone);
  if (d.length !== 10) return phone;
  return `(${d.slice(0, 3)}) ${d.slice(3, 6)}-${d.slice(6)}`;
}

/**
 * WhatsApp deep link for a US phone number.
 */
export function waLink(phone: string): string {
  return `https://wa.me/1${cleanPhone(phone)}`;
}

/**
 * tel: URI for a US phone number.
 */
export function telLink(phone: string): string {
  return `tel:+1${cleanPhone(phone)}`;
}

/**
 * sms: URI for a US phone number.
 */
export function smsLink(phone: string): string {
  return `sms:+1${cleanPhone(phone)}`;
}
